import React from "react";
import { exportToCsv, exportToXlsx } from "./exporters";

export default function ExportButton({ rows, columns, filenameBase, sheetName, disabled }) {
  const onCsv = () =>
    exportToCsv({ rows, columns, filename: `${filenameBase}.csv` });

  const onXlsx = async () => {
    try {
      await exportToXlsx({ rows, columns, filename: `${filenameBase}.xlsx`, sheetName: sheetName || "Data" });
    } catch (e) {
      alert("XLSX export requires the 'xlsx' package. Run: npm i xlsx");
    }
  };

  return (
    <div className="btn-group">
      <button className="btn btn-outline-secondary btn-sm" onClick={onCsv} disabled={disabled}>
        Export CSV
      </button>
      <button className="btn btn-outline-secondary btn-sm" onClick={onXlsx} disabled={disabled} title="Requires 'xlsx' package">
        Export Excel
      </button>
    </div>
  );
}
